import styled from 'styled-components';

export const Message = styled.div`
  color: var(--text-secondary);
  font-size: var(--text-sm);
  line-height: 1.55;
  overflow-wrap: anywhere;

  p + p { margin-top: 8px; }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--spacing-sm) var(--spacing-md);
  margin-top: var(--spacing-lg);

  @media (max-width: 560px) {
    flex-direction: column-reverse;
    > * { width: 100%; }
  }
`;
